<div class="g-0" [hidden]="uploading">
  <div class="row g-2">
    @if (collectClient) {
      <div class="col-12 col-md-3">
        <label class="my-0"><strong>Client</strong></label>
        <app-client-select
          [autoLoad]="true"
          [listFilters]="{ applicableToIccClaims: true }"
          name="clientId"
          placeholder="-- Choose Client --"
          [multiple]="false"
          [(selectedId)]="formModel.clientId" />
      </div>
    }

    @if (collectThirdPartyAdminister) {
      <div class="col-12 col-md-3">
        <label class="my-0"><strong>TPA</strong></label>
        <div class="input-group">
          <select class="form-select" [(ngModel)]="formModel.thirdPartyAdministerId" name="thirdPartyAdministerId">
            <option value="" [selected]="true"> -- Choose TPA -- </option>
            @for (thirdPartyAdminister of thirdPartyAdministers; track thirdPartyAdminister) {
              <option [value]="thirdPartyAdminister.id">{{ thirdPartyAdminister.name }}</option>
            }
          </select>
        </div>
      </div>
    }

    <div class="col-12 col-md-3">
      <label class="my-0"><strong>File Name</strong> (optional)</label>
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="formModel.name" />
      </div>
    </div>

    <div class="col-12 col-md-4">
      <app-file-upload
        [fileType]="'.csv'"
        [uploadButtonDisabled]="uploadButtonDisabled"
        (fileSelected)="onFileSelected($event)"
        (uploadStart)="onUploadStart()"
        (uploadCancel)="onUploadCancel()"
        (uploadError)="onUploadError()"
        (uploadComplete)="onUploadComplete($event)" />
    </div>
  </div>
</div>
